module.exports = __webpack_public_path__ + "static/media/mattv.6b160ab4.webp";